<template>
  <!-- eslint-disable vue/no-unused-components -->
  <div>
    <slot v-bind="{
      activator, status, chatroom, members, allMessages, interactions, input
    }">
    </slot>
  </div>
</template>

<script>
// For Development and Debugging
const $filepath = "@/src/developing/components/chat/engine.vue";
const functionDebugger = _functionDebugger($filepath);

/* eslint-disable vue/no-unused-components */

// import ChatStoreModule from "@/store/modules/chat";
// import UserStoreModule from "@/store/modules/user";

let $vm, $data = {};
import Vue from "vue";
import $store from "@/store";

prepare();

export default {
  async beforeCreate() {
    $vm = this;
  },
  async mounted() {
    if (this.$currentUser.active) {
      await this.chatActivator(this.activator);
    }
  },
  data: () => $data,
  props: {
    activator: {
      type: Array,
      required: true
    }
  },
  watch: {
    "$store.state.User.currentUser": {
      handler: async function (/* currentUser */) {
        // await this.getChatRoom();
        await this.chatActivator(this.activator);
      },
      deep: true
    },
    "member_ids": {
      /* Watching for changes on member element (in both All, Active and Ban members)
       */
      handler: async function (members, /* prevMembers */) {
        this.members = await this.setAllMemberStatus(members);
        $data.status.loading = false;
      },
      deep: true
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    interactions() {
      return {
        sendMessage: this.sendMessage
      }
    },
  },
  methods: {
    resetChatMessageInput,
    getUserWithPublicProfile,
    chatActivator,
    getChatRoom,
    getChatRoomByAssociativeKey,
    setupChatRoom,
    subscribeToChatRoomChannel,
    setAllMemberStatus,
    processMessageSendingQueue,
    findDiffOfMembers,
    sendMessage,
    onMessageSent
  },
}

async function prepare() {
  // Set Local Data
  $data = setDefaultData();

  if (!$store.state.Chat) { $store.registerModule('Chat', (await import("@/store/modules/chat")).default) }
}

function setDefaultData() {
  return Vue.observable({
    chatroom: {
      id: null
    },
    status: {
      initializing: true,
      error: false,
      loading: true,
    },
    clickNotClose         : false,
    activeChatUser        : 1231231230,
    settings              : {
      maxScrollbarLength    : 60,
      wheelSpeed            : 0.70,
    },
    input: {
      chatMessageInput: { content: "" },
    },
    currentChatMessageSet: {},
    processing: false,
    subscriber: null,
    members: [], // Sorted array of member info objects (including uuid, active status, active timestamp, profiles, ...)
    member_ids: {
      all: [],
      active: [],
      ban: [],
    },
    allMessages: {
      chatMessages: [],
      previousChatMessages: [],
      sendingQueue: [],
      processingQueue: [],
    }
  });
}

async function chatActivator(activator) {
  functionDebugger(chatActivator);

  if (activator) {
    // const associativeKey = `${activator.feature}:${activator.id}`;
    $vm.getChatRoomByAssociativeKey(activator);

    // Set mode for chatroom according to activator calling.
  }
  $vm.error = true;
  $vm.errorStatus = { message: "No chatroom requested" }
}

async function getChatRoom(chatroomID) {
  functionDebugger(getChatRoom);

  const userUUID = $vm.$currentUser.uuid;

  const chatroom = await $vm.$store.dispatch("Chat/getChatroomById",
    { id: chatroomID, userUUID },
    { root: true }
  );

  if (chatroom.status.success) {
    await $vm.setupChatRoom(chatroom.data);
  }
}

async function getChatRoomByAssociativeKey(keys) {
  functionDebugger(getChatRoomByAssociativeKey);

  // TODO: Show error UI in case that no associative key to open a chat room
  if (!keys) { return }

  const chatroom = await $vm.$store.dispatch("Chat/getChatroomByAssociativeKey",
    { associateFeatureInput: keys },
    { root: true }
  );

  // TODO: Show error UI in case that the chatroom doesn't exists.
  if (!chatroom) { return }

  if (chatroom.status.success) {
    await $vm.setupChatRoom(chatroom.data);
  }

  if (chatroom.status.error) {
    $vm.status.error = true;
    $vm.status.message = chatroom.status.message;
  }
}

async function setupChatRoom(chatroom) {
  functionDebugger(setupChatRoom);

  $data.status.loading = true;

  const userUUID = $vm.$currentUser.uuid;

  if (chatroom) {
    $vm.chatroom = chatroom;

    await $vm.subscribeToChatRoomChannel($vm.chatroom, userUUID);

    $vm.currentChatMessageSet = $vm.chatroom.chatMessageSet[0];

    for (let chatMessageSet of $vm.chatroom.chatMessageSet) {
      for (let message of chatMessageSet.messages) {
        $vm.allMessages.chatMessages.push(JSON.parse(message));
      }
      if ($vm.currentChatMessageSet.previousMessages) {
        for (let message of $vm.currentChatMessageSet.previousMessages) {
          $vm.allMessages.previousChatMessage.push(JSON.parse(message));
        }
      }
    }

    // Convert each member data from JSON to Map
    $vm.chatroom.members = new Map($vm.chatroom.members.map(_member => {
      const member = JSON.parse(_member);
      return [member.uuid, member]
    }));

    // Set All Member List
    $vm.member_ids.all = new Set($vm.chatroom.members.keys());

    // Set Active User List
    // $vm.member_ids.active = $vm.chatroom.activeUserList.map(member => JSON.parse(member));
    $vm.member_ids.active = $vm.chatroom.activeUserList;

    // Set Banned User List
    // $vm.members.ban = $vm.chatroom.bannedUserList;

    // Setup all member with their status.
    $vm.members = await $vm.setAllMemberStatus($vm.member_ids);
    $data.status.loading = false;
  }
}

async function subscribeToChatRoomChannel (chatroom, userUUID, subscriberInstance) {
  functionDebugger(subscribeToChatRoomChannel);

  let subscriber = subscriberInstance || $vm.subscriber;

  if (!subscriber && chatroom.id) {

    const sseUrl = `${process.env.VUE_APP_API_SERVER}/sse/chatroom/${chatroom.id}
    ?chatroomID=${chatroom.id}
    &userUUID=${userUUID}`;

    subscriber = new EventSource(sseUrl);

    subscriber.onmessage = async (event) => {
      const { signals, payloads } = JSON.parse(event.data);

      console.log("Subscriber on Message", event.data);

      if (signals.indexOf("update-chat-messages") > -1) {
        const _newMessages = payloads["update-chat-messages"];
        const newMessages = _newMessages.map(message => JSON.parse(message));
        $vm.allMessages.chatMessages = $vm.allMessages.chatMessages.concat(newMessages);

      }

      if (signals.indexOf("update-member-active") > -1) {
        const { uuid, timestamp } = payloads["update-member-active"];
        if ($vm.member_ids.active.indexOf(uuid) === -1) {
          $vm.member_ids.active.push({ uuid, timestamp });
          $vm.members = await $vm.setAllMemberStatus($vm.member_ids);
        }
      }

      if (signals.indexOf("update-member-inactive") > -1) {
        const { uuid } = payloads["update-member-inactive"];
        $vm.member_ids.active.splice($vm.member_ids.active.indexOf(uuid), 1);

        $vm.members = await $vm.setAllMemberStatus($vm.member_ids);
      }
    };

    if (!$vm.subscriber) $vm.subscriber = subscriber;

    $data.status.initializing = false;
  }
}

// To promptly set all member status with public profile for use on subcomponents.
// TODO: Need recheck
async function setAllMemberStatus(members_uuid) {
  functionDebugger(setAllMemberStatus);

  // Get difference list of members (Expect not banned members)
  const diff = $vm.findDiffOfMembers(members_uuid);

  // Convert data inside active list of members
  const active = members_uuid.active.map(uuid => {
    const member = $vm.chatroom.members.get(uuid);
    if (member) {
      const timestamp = member.timestamp || new Date().getTime();
      return {
        ...member,
        uuid,
        timestamp,
        active: true
      };
    }
  });

  // Merged records of uuid of members from both active and inactive list (no banned list)
  const merge = [ ...diff, ...active];

  // Sorted, resolved and get profile of members
  return await Promise.all(
    merge
    .sort((a, b) => (a.uuid === b.uuid) ? 0 : a.uuid ? -1 : 1)
    .map(async member => await $vm.getUserWithPublicProfile(member))
    .filter(member => member !== null)
  );
}

function findDiffOfMembers(members_uuid) {
  functionDebugger(findDiffOfMembers);

  // Find difference of arrays of members be returning only remains of all members array
  // that was reduced from active member list and banned member list.

  /*
 */
  const { all, banned, active } = members_uuid;
  const _all = Array.from(all);
  const _active = [...active];
  const exclusive = _active.concat(banned);
  return _all.filter(uuid => exclusive.indexOf(uuid) < 0).map(uuid => {
    const member = $vm.chatroom.members.get(uuid);
    return {
      uuid,
      ...member,
    };
  })

 // Remember that ALL Member here is not about 7-11. Good!

}

// TODO: Need to recheck and fix
// TODO: Implement Caching to IndexedDB
async function getUserWithPublicProfile(member = {}) {
  functionDebugger(getUserWithPublicProfile);
  let userPublicProfile = {};

  if (member.uuid) {
    const userUUID = member.uuid;

    // Set Flatmap Cache
    if (!$vm.$flatmap.has(member.uuid)) {
      userPublicProfile = await $vm.$store.dispatch("User/getPublicProfile", { userUUID });
      $vm.$flatmap.set(member.uuid, userPublicProfile);
    }

    userPublicProfile = $vm.$flatmap.get(member.uuid);

    // Set Fullname
    if (userPublicProfile) {
      userPublicProfile.fullname = userPublicProfile.nameLocal + " " + userPublicProfile.surnameLocal;
    }
  }
  return { ...member, ...userPublicProfile };
}

async function sendMessage() {
  functionDebugger(sendMessage);

  const timestamp = new Date().getTime();
  const senderUUID = $vm.$currentUser.uuid;
  const chatMessage = {
    id: $vm.chatroom.id + "/" + timestamp + "/" + senderUUID,
    timestamp,
    senderUUID,
    ...$vm.input.chatMessageInput
  };
  $vm.allMessages.sendingQueue.push(chatMessage);
  $vm.resetChatMessageInput();

  await $vm.processMessageSendingQueue();
}

// Throttling and sending message in batch
async function processMessageSendingQueue() {
  if ($vm.processing === false) {
    $vm.processing = true;
    $vm.allMessages.processingQueue = [...$vm.allMessages.sendingQueue];
    $vm.allMessages.sendingQueue = [];
    setTimeout(async () => {
      const messageSentResult = await $vm.$store.dispatch("Chat/sendChatMessages",
        {
          chatroomID: $vm.chatroom.id,
          chatMessagesInput: [ ...$vm.allMessages.processingQueue ].map(message => ({ ...message }))
        },
        { root: true }
      );
      $vm.onMessageSent(messageSentResult);
      if ($vm.allMessages.sendingQueue.length > 0) {
        $vm.processMessageSendingQueue();
      }
    }, 500);
  }
}

function onMessageSent(/* messageSentResult */) {
      // const sentMessage = $vm.processingQueue.map(message => ({ ...message, sent: true }));
      // $vm.chatMessages = $vm.chatMessages.concat(sentMessage);
      $vm.processing = false;
      $vm.allMessages.processingQueue = [];
}


function resetChatMessageInput() {
  $vm.input.chatMessageInput = { content: "" };
}



function _functionDebugger (filepath) {
  if (!filepath) { return () => null }
  return function(fn = null) {
    if (!fn) { return () => null }
    const functionName = fn.toString().split("(")[0];
    const $location = `${functionName}() in ${filepath}`;
    console.log($location);
  }
}

</script>
